import { apiClient } from "../../../config/apiClient";
import {
    CREATE_PREFERENCE_ERROR, CREATE_PREFERENCE_REQUEST, CREATE_PREFERENCE_SUCCESS,
    DELETE_EVENT_FAILURE,
    DELETE_EVENT_REQUEST,
    DELETE_EVENT_SUCCESS,
    EVENT_ERROR,
    EVENT_REQUEST,
    EVENT_SUCCESS,
    FETCH_EVENT_FAILURE,
    FETCH_EVENT_REQUEST,
    FETCH_EVENT_SUCCESS,
    GET_PREFERENCE_ERROR, GET_PREFERENCE_REQUEST, GET_PREFERENCE_SUCCESS,
} from "../actiontypes";

export const getPreference = () => {
    return async (dispatch) => {
        dispatch(getPreferenceRequest())
        await apiClient(true).get(`api/signee/get-preferences`)
            .then(response => {
                dispatch(getPreferenceSuccess(response.data))
            }).catch(error => {
                dispatch(getPreferenceError(error))
            })
    }
}

export const getPreferenceRequest = () => {
    return {
        type: GET_PREFERENCE_REQUEST
    }
}
export const getPreferenceSuccess = (data) => {
    return {
        type: GET_PREFERENCE_SUCCESS,
        payload: data
    }
}
export const getPreferenceError = (error) => {
    return {
        type: GET_PREFERENCE_ERROR,
        payload: error
    }
}
// -----------------------------

export const createPreference = (data) => {
    return async (dispatch) => {
        dispatch(createPreferenceRequest())
        await apiClient(true).put(`api/signee/add-preferences`, data)
            .then(response => {
                const data = response.data
                if (data.status === true) {
                    dispatch(createPreferenceSuccess(data))
                    // setTimeout(() => {
                    //     dispatch(getPreference())
                    // }, 2000);
                } else {
                    dispatch(createPreferenceError(data))
                }
            }).catch(error => {
                dispatch(createPreferenceError(error))

            })
    }
}

export const createPreferenceRequest = () => {
    return {
        type: CREATE_PREFERENCE_REQUEST
    }
}
export const createPreferenceSuccess = (data) => {
    return {
        type: CREATE_PREFERENCE_SUCCESS,
        payload: data
    }
}
export const createPreferenceError = (error) => {
    return {
        type: CREATE_PREFERENCE_ERROR,
        payload: error
    }
}



export const saveEvent = (data) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    return async (dispatch) => {
        dispatch(eventRequest());
        await apiClient(true)
            .post(`api/organization/add-candidate-avaibility `, data, {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + loggedInUser,
                },
            })
            .then((response) => {
                const dataItem = response.data;
                dispatch(eventSuccess(dataItem));
            })
            .catch((error) => {
                const errMsg =
                    error.response?.data || error || "Something went wrong.";
                dispatch(eventFailure(errMsg));
            });
    };
};

const eventRequest = () => {
    return {
        type: EVENT_REQUEST,
    };
};

const eventSuccess = (data) => {
    return {
        type: EVENT_SUCCESS,
        payload: data,
    };
};

const eventFailure = (error) => {
    return {
        type: EVENT_ERROR,
        payload: error,
    };
};


// Fetch Candidate event
export const fetCandidateEvent = (data) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    return async (dispatch) => {
        dispatch(fetchEventRequest());
        await apiClient(true).get(`api/organization/fetchAll-event`, {
            params: data, // this becomes ?key=value in the URL
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${loggedInUser}`,
            },
        }).then((response) => {
            dispatch(fetchEventSuccess(response.data.data));
        }).catch((error) => {
            const errMsg =
                error.response?.data || error || "Something went wrong.";
            dispatch(fetchEventFailure(errMsg));
        });
    };
};

const fetchEventRequest = () => {
    return {
        type: FETCH_EVENT_REQUEST,
    };
};

const fetchEventSuccess = (data) => {
    return {
        type: FETCH_EVENT_SUCCESS,
        payload: data
    };
};

const fetchEventFailure = (data) => {
    return {
        type: FETCH_EVENT_FAILURE,
        payload: data
    };
};




export const deleteCandidateEvent = (data) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    return async (dispatch) => {
        dispatch(deleteEventRequest());
        await apiClient(true).delete(`api/organization/delete-event`, {
            params: data,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${loggedInUser}`,
            },
        }).then((response) => {
            dispatch(deleteEventSuccess(response.data.data));
        }).catch((error) => {
            const errMsg =
                error.response?.data || error || "Something went wrong.";
            dispatch(deleteEventFailure(errMsg));
        });
    };
};

const deleteEventRequest = () => {
    return {
        type: DELETE_EVENT_REQUEST,
    };
}
const deleteEventSuccess = (data) => {
    return {
        type: DELETE_EVENT_SUCCESS,
        payload: data
    };
}
const deleteEventFailure = (data) => {
    return {
        type: DELETE_EVENT_FAILURE,
        payload: data
    };
}